import { render, staticRenderFns } from "./goCheck.vue?vue&type=template&id=6fd5a8ed&scoped=true&"
import script from "./goCheck.vue?vue&type=script&lang=js&"
export * from "./goCheck.vue?vue&type=script&lang=js&"
import style0 from "./goCheck.vue?vue&type=style&index=0&id=6fd5a8ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5a8ed",
  null
  
)

export default component.exports